<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="`DD #${item.reference}`" :subtitle="`Status: ${item.status}`">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">

            <ui-data-grid v-if="isActive('overview')">
                <ui-data-grid-item label="Package">
                    <template v-if="item.package_id"><a class="text-brand"
                                                        :href="item._links.frontend.package">{{ item.package_name }}</a>
                    </template>
                    <template v-else>{{ item.package_name }}</template>
                </ui-data-grid-item>
                <ui-data-grid-item label="Status" :value="item.status"></ui-data-grid-item>
                <ui-data-grid-item label="Requested By (Hambro Contact)">
                    <a class="font-medium text-gray-900" :href="item.hambro_contact._links.frontend.view"
                       v-if="item.hambro_contact.value">
                        {{ item.hambro_contact.name }}
                    </a>
                    <p v-else>Not Set</p>
                </ui-data-grid-item>
                <ui-data-grid-item label="Delivery / Collection Contact">
                    <a class="font-medium text-gray-900" :href="item.site_contact._links.frontend.view"
                       v-if="item.site_contact.value">
                        {{ item.site_contact.name }}
                    </a>
                    <p v-else>Not Set</p>
                </ui-data-grid-item>
                <ui-data-grid-item label="Requested For / Due" :value="item.due"></ui-data-grid-item>
                <ui-data-grid-item label="Deliver To" :value="item.delivery_string"></ui-data-grid-item>
                <ui-data-grid-item label="Related To" :value="item.to_string"></ui-data-grid-item>
                <ui-data-grid-item label="Additional" :value="item.additional"></ui-data-grid-item>

                <ui-data-grid-item label="Materials Requested" wide>
                    <div v-if="item.items.length === 0">—</div>
                    <materials-list v-else :materials="item.items"></materials-list>
                </ui-data-grid-item>
                <ui-data-grid-item label="Quick action" wide>
                    <div class="flex flex-col md:flex-row flex-wrap -m-2">
                        <a :href="item.getDownloadUrl()" tabindex="-1">
                            <ui-button-new class="m-2" icon="fas fa-file-pdf">Download As PDF</ui-button-new>
                        </a>
                        <template v-if="!item.void">
                            <ui-button-new v-if="item.status_id != 300" class="m-2" icon="fas fa-truck-loading"
                                           @click="item.markAsDispatched()" success>Mark As Dispatched
                            </ui-button-new>
                            <ui-button-new v-if="item.status_id != 200" class="m-2" icon="fas fa-box-open"
                                           @click="item.markAsPicked()" success>Mark As Picked
                            </ui-button-new>
                            <ui-button-new v-if="item.status_id != 100" class="m-2" icon="fas fa-ellipsis-h"
                                           @click="item.markAsPending()" warning>Mark As Pending
                            </ui-button-new>
                            <ui-button-new v-if="item.status_id < 300" class="m-2" icon="fas fa-times-circle"
                                           @click="item.voidDocket()" danger>Void Docket
                            </ui-button-new>
                        </template>
                        <ui-button-new v-else class="m-2" icon="fas fa-star" @click="item.restoreDocket()" success>
                            Restore
                            Docket
                        </ui-button-new>
                    </div>
                </ui-data-grid-item>

                <ui-data-grid-item label="Created By">{{ item.created_by }} on {{ item.created_at }}</ui-data-grid-item>
                <ui-data-grid-item label="Last Updated By">{{ item.updated_by }} on {{
                        item.updated_at
                    }}
                </ui-data-grid-item>
            </ui-data-grid>

            <ui-data-grid v-else-if="isActive('files')" class="w-full">
                <filesystem compact="true" :filesystem-id="item.filesystem_id"></filesystem>
            </ui-data-grid>

            <ui-data-grid v-else-if="isActive('notes')" class="w-full">
                <notes :get-url="item._links.notes_url" :post-url="item._links.notes_url"></notes>
            </ui-data-grid>


        </ui-tabs>
    </ui-container>
</template>

<script>
export default {
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
    },
    computed: {
        tabs() {
            return [
                {value: 'overview', label: 'Overview'},
                {value: 'files', label: 'Files'},
                {value: 'notes', label: 'Notes'}
            ]
        },
    },
    methods: {
        openDeleteModal() {
            const title = 'Are you sure you want to remove dispatch docket ' + this.item.reference + '?'
            const description = 'You are removing dispatch docket ' + this.item.reference + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
